import findResult, { findMatch } from '@/utils/resultsHelper';

export const findDataModelReport = (reportsData, category, code, reportId, attribute = 'id') => {
  const reports = findResult(reportsData, category, code);

  return reports ? findMatch(reports.items, reportId, attribute) : null;
};

const findDictionaryReportType = (reportsData, category, code, reportType, reportId, attribute = 'id') => {
  const item = findResult(reportsData, category, code);
  const reports = item ? item[reportType] : null;

  return reports ? findMatch(reports.items, reportId, attribute) : null;
};

export default findDictionaryReportType;
